import { Environment } from "../types/environment";

export const environment: Environment = {
  production: false,
  type: 'mobile',
  recaptcha: {
    siteKey: '6LfiO90rAAAAAL_EBohO2KZKCcrL1H1MJ3TWRAPW' // test
  },
  covenantApiUrl: 'https://apiapp-test.repas.it/v1/covenant-web',
  geoServicesApiUrl: 'https://apiapp-test.repas.it/v1/geoservices',
  storesApiUrl: 'https://apiapp-test.repas.it/v1/stores-web',
  supportApiUrl: 'https://apiapp-test.repas.it/v1/support'
};

export function backToApp() {
  window.location.href = 'web-link://back';
}

export function callPhone(number: string) {
  window.location.href = `tel:${number}`;
}